@if (cart.items().length === 0) {
  <div class="c-cart__empty">
    <i class="bx bx-cart c-cart__empty-icon"></i>
    <p class="c-cart__empty-text">Seu carrinho está vazio</p>
  </div>
} @else {
  <ul class="c-cart__list">
    @for (item of cart.items(); track item.productId) {
      <li class="c-cart__item">
        @if (item.imageUrl) {
          <img
            class="c-cart__item-img"
            [src]="item.imageUrl"
            [alt]="item.name"
            loading="lazy"
          />
        }

        <div class="c-cart__item-info">
          <span class="c-cart__item-name">{{ item.name }}</span>

          @if (item.adicionais.length > 0) {
            <ul class="c-cart__item-extras">
              @for (extra of item.adicionais; track extra.id) {
                <li class="c-cart__item-extra">+ {{ extra.label }}</li>
              }
            </ul>
          }

          <span class="c-cart__item-unit">
            {{ item.unitPrice | currency: 'BRL' : 'symbol' : '1.2-2' : 'pt-BR' }} / un
          </span>
        </div>

        <div class="c-cart__item-controls">
          <div class="c-cart__stepper">
            <button
              type="button"
              class="c-cart__stepper-btn"
              (click)="decrement(item.productId)"
              aria-label="Diminuir"
            >
              <i class="bx bx-minus"></i>
            </button>

            <span class="c-cart__stepper-value">{{ item.quantity }}</span>

            <button
              type="button"
              class="c-cart__stepper-btn"
              (click)="increment(item.productId)"
              aria-label="Aumentar"
            >
              <i class="bx bx-plus"></i>
            </button>
          </div>

          <strong class="c-cart__item-total">
            {{ itemTotal(item) | currency: 'BRL' : 'symbol' : '1.2-2' : 'pt-BR' }}
          </strong>

          <button
            type="button"
            class="c-cart__item-remove"
            (click)="cart.remove(item.productId)"
            aria-label="Remover item"
          >
            <i class="bx bx-trash"></i>
          </button>
        </div>
      </li>
    }
  </ul>

  <div class="c-cart__summary">
    <span class="c-cart__summary-label">Total</span>
    <strong class="c-cart__summary-total">
      {{ cart.total() | currency: 'BRL' : 'symbol' : '1.2-2' : 'pt-BR' }}
    </strong>
  </div>

  <button type="button" class="c-cart__checkout-btn" (click)="goToCheckout()">
    Finalizar pedido
  </button>
}
